// Types
import { Env } from '../Constants'
import {
  type Context,
  type ConversationCounterPayload,
  type PostCounterPayload,
  type InboxCounterPayload,
} from '../types/ContextTypes'

// Constants
export const name = {
  SEND_CONTEXT: 'SEND_CONTEXT',
  SEND_MULTIPLE_CONTEXTS: 'SEND_MULTIPLE_CONTEXTS',
  RECEIVE_CONTEXTS: 'RECEIVE_CONTEXTS',
  RECEIVE_PRIVATE_CONTEXT: 'RECEIVE_PRIVATE_CONTEXT',
  RECEIVE_PUBLIC_CONTEXT: 'RECEIVE_PUBLIC_CONTEXT',
  RECEIVE_COUNTERS: 'RECEIVE_COUNTERS',
}

export function isDev() {
  return Env === undefined || Env === null || Env.toString() === 'development'
}

export function isDebugSocket() {
  return false
}
/**
 *
 * Display the given context in Reactotron
 *
 * @export
 * @param {Context} context
 */
export function debugContext(name: string, context: Context) {
  if (isDev()) {
    console.log({
      name: name,
      value: context,
      preview: `TYPE: ${context.type}`,
      important: false,
    })
  }
}

/**
 *
 * Display the given contexts in Reactotron
 *
 * @export
 * @param {string} name
 * @param {Array<Context>} contexts
 */
export function debugContexts(name: string, contexts: Array<Context>) {
  if (isDev()) {
    console.log({
      name: name,
      value: contexts,
      important: false,
    })
  }
}

/**
 *
 * Display the given counters in Reactotron
 *
 * @export
 * @param {(Array<InboxCounterPayload | ConversationCounterPayload | PostCounterPayload>)} counters
 */
export function debugCounters(
  counters: Array<
    InboxCounterPayload | ConversationCounterPayload | PostCounterPayload
  >
) {
  if (isDev()) {
    console.log({
      name: name.RECEIVE_COUNTERS,
      value: counters,
      important: false,
    })
  }
}
